export default {
    testimonial: "Our organization is scaling incredibly fast. The monday.com platform has kept up with our needs, flexing to fill in the gaps as we continue to grow."
};
